import Vue from 'vue';

export default {
    init() {
        if (window.route) {
            Vue.mixin({
                methods: {
                    route: window.route,
                },
            });
        }
    },
};
